import { tv } from "@ui/lib/tv";
import type { CardTheme } from "@ui/types/card";
import type { ReactNode } from "react";

const cardText = tv({
  slots: {
    title: "line-clamp-1 text-neutral-900",
    description: "line-clamp-3 text-neutral-600",
  },
  variants: {
    theme: {
      editorial: {
        title: "text-lg font-semibold leading-6 md:text-xl md:leading-7",
        description: "text-sm font-normal leading-5 md:text-base md:leading-6",
      },
      compact: {
        title: "text-lg font-extrabold leading-6",
        description: "text-sm font-normal leading-5",
      },
    },
  },
  defaultVariants: { theme: "editorial" },
});

export interface CardTitleProps {
  children: ReactNode;
  className?: string;
  /** Visual treatment: "editorial" for spacious layouts, "compact" for dense grids. */
  theme?: CardTheme;
}

export function CardTitle({ children, className, theme }: CardTitleProps) {
  return <h3 className={cardText({ theme }).title({ className })}>{children}</h3>;
}

export interface CardDescriptionProps {
  children: ReactNode;
  className?: string;
  /** Visual treatment: "editorial" for spacious layouts, "compact" for dense grids. */
  theme?: CardTheme;
}

export function CardDescription({ children, className, theme }: CardDescriptionProps) {
  return <p className={cardText({ theme }).description({ className })}>{children}</p>;
}
